import { CSS, StyleProps } from "../../styles"

export const root = (): CSS => ({
  display: `block`,
  marginTop: `-70px`,
  textAlign: `center`,
})

export const label = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.title,
  ...props.theme.fonts.subHeading,
})
